/**
 * Filtros do Mapa em estado React, salvos no navegador por unidade a cada
 * mudança (filtros.js decide o que salvar). O mapa geral e a página do setor
 * usam o mesmo hook, então o gestor não refaz o filtro ao entrar no setor.
 */
import { useCallback, useEffect, useMemo, useState } from "react";

import {
  contarAtivos,
  criarFiltrosVazios,
  lerFiltrosSalvos,
  normalizarFiltros,
  removerFiltro,
  salvarFiltros,
} from "./filtros";

/**
 * → {filtros, definirFiltro(id, valor), removerFiltro(id), limparFiltros(),
 *    substituirFiltros(filtros), totalAtivos}
 */
export default function useFiltrosDoMapa() {
  const [filtros, setFiltros] = useState(lerFiltrosSalvos);

  useEffect(() => {
    salvarFiltros(filtros);
  }, [filtros]);

  const definirFiltro = useCallback(
    (id, valor) => setFiltros((atuais) => normalizarFiltros({ ...atuais, [id]: valor })),
    []
  );
  const remover = useCallback((id) => setFiltros((atuais) => removerFiltro(atuais, id)), []);
  const limparFiltros = useCallback(() => setFiltros(criarFiltrosVazios()), []);
  const substituirFiltros = useCallback((novos) => setFiltros(normalizarFiltros(novos)), []);
  const totalAtivos = useMemo(() => contarAtivos(filtros), [filtros]);

  return { filtros, definirFiltro, removerFiltro: remover, limparFiltros, substituirFiltros, totalAtivos };
}
